import {
  PERSONALIZED_FEED_SUCCESS,
  PERSONALIZED_FEED_REQUESTED,
  PERSONALIZED_FEED_ERROR,
} from './PersonalizedSection-Actions';

const initialState = {
  data: {},
  isLoading: true,
  isError: false,
  error: null,
};
const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case PERSONALIZED_FEED_REQUESTED:
      return {
        ...initialState,
        isLoading: true,
      };
    case PERSONALIZED_FEED_SUCCESS:
      return {
        ...state,
        ...{ isLoading: false, data: action.payload },
      };
    case PERSONALIZED_FEED_ERROR:
      return {
        ...state,
        ...{
          data: {},
          isLoading: false,
          isError: true,
          error: action.payload.message,
        },
      };
    default:
      return state;
  }
};

export default Reducer;
